import { lazy, Suspense } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

// Lazy‑load all page components
const HomePage = lazy(() => import('../pages/home/page'));
const HomeFeedPage = lazy(() => import('../pages/home-feed/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const OrganizationPage = lazy(() => import('../pages/organization/page'));
const NoticesPage = lazy(() => import('../pages/notices/page'));
const EvaluationPage = lazy(() => import('../pages/evaluation/page'));
const SelfReviewPage = lazy(() => import('../pages/self-review/page'));
const PeerReviewPage = lazy(() => import('../pages/peer-review/page'));
const DownwardReviewPage = lazy(() => import('../pages/downward-review/page'));
const CalibrationPage = lazy(() => import('../pages/calibration/page'));
const EvaluationResultPage = lazy(() => import('../pages/evaluation-result/page'));
const EvaluationCreatePage = lazy(() => import('../pages/evaluation-create/page'));
const EvaluationManageDetailPage = lazy(() => import('../pages/evaluation-manage-detail/page'));
const CompetencyPage = lazy(() => import('../pages/competency/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const PortalPage = lazy(() => import('../pages/portal/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: '/portal',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <PortalPage />
      </Suspense>
    ),
  },
  {
    path: '/home',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/home-feed',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <HomeFeedPage />
      </Suspense>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <DashboardPage />
      </Suspense>
    ),
  },
  {
    path: '/organization',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <OrganizationPage />
      </Suspense>
    ),
  },
  {
    path: '/competency',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <CompetencyPage />
      </Suspense>
    ),
  },
  {
    path: '/notices',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NoticesPage />
      </Suspense>
    ),
  },
  {
    path: '/evaluation',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <EvaluationPage />
      </Suspense>
    ),
  },
  {
    path: '/evaluation/manage/detail/:id',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <EvaluationManageDetailPage />
      </Suspense>
    ),
  },
  {
    path: '/self-review',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <SelfReviewPage />
      </Suspense>
    ),
  },
  {
    path: '/peer-review',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <PeerReviewPage />
      </Suspense>
    ),
  },
  {
    path: '/downward-review',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <DownwardReviewPage />
      </Suspense>
    ),
  },
  {
    path: '/calibration',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <CalibrationPage />
      </Suspense>
    ),
  },
  {
    path: '/evaluation-result',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <EvaluationResultPage />
      </Suspense>
    ),
  },
  {
    path: '/evaluation/create',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <EvaluationCreatePage />
      </Suspense>
    ),
  },
  {
    path: '/evaluation/edit/:id',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <EvaluationCreatePage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<div>Loading…</div>}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
